/*core/menus*/
function _(require, module, exports) {
    var signaling_1 = require(19    /* ./signaling */);
    exports.clear_menus = new signaling_1.Signal0({}, 'clear_menus');
    document.addEventListener('click', function () {
        return exports.clear_menus.emit();
    });    
}